import { render, staticRenderFns } from "./missed_customers.vue?vue&type=template&id=68dcbb86"
import script from "./missed_customers.vue?vue&type=script&lang=js"
export * from "./missed_customers.vue?vue&type=script&lang=js"
import style0 from "./missed_customers.vue?vue&type=style&index=0&id=68dcbb86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports